/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IScrollIntoViewViewProps } from './scroll-into-view';

export default (props: IScrollIntoViewViewProps) => {
    const { config } = props;
    const { ariaLabel, smooth, className, selector, label, tooltip } = config;
    return (
        <button
            onClick={event => {
                event.preventDefault();
                const element = document.querySelector(selector);
                element?.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto' });
            }}
            aria-label={ariaLabel}
            className={`scroll-into-view ${className ?? ''}`}
            title={tooltip}
            tabIndex={0}
        >
            {label}
        </button>
    );
};
